import wrapper from "./wrapper";

export default {
  /**
   * create - Jigsaw.User.create
   * @param {Object} params - new user params
   * @param {string} params.last_brand_accessed - sets up the last brand accessed for the user
   * @param {string} params.email - New user's email address
   * @param {string} params.first_name - New user's first name
   * @param {string} params.last_name - New user's last name
   * @param {string} params.password - New user's password
   * @param {string} params.password_confirmation - New user's password [confirmation] - needs to match password
   * @param {integer} params.question_id - Question ID for new user security question
   * @param {string} params.question_response - Response for new user security question
   * @param {boolean} params.eula_accepted - Should the new user be created with an accepted terms of service?
   * @param {boolean} params.notify - This is for the checkboxes on if we should send the user marketing/update emails.  We always set to false now.
   */
  create: params => wrapper("User.create", params),

  /**
   * mergeAccount - merges the currently logged in user into the user given by email and password
   * @param {Object} params - email and password parameters
   * @param {string} params.email - email for the account to merge into
   * @param {string} params.password - password for the account to merge into
   */
  mergeAccount: params => wrapper("User.mergeAccount", params),

  /**
   * create - Jigsaw.User.exists - check if a user is already registered to that email address
   * @param {strinng} email - Email address to check existence
   */
  exists: email => wrapper("User.exists", email),

  /**
   * getInfo - Jisgaw.User.getInfo
   */
  getInfo: () => wrapper("User.getInfo"),

  /**
   * updateLicense - Jigsaw.User.updateLicense
   */
  updateLicense: () => wrapper("User.updateLicense"),

  asyncUpdateLicense: () => wrapper("User.asyncUpdateLicense"),

  asyncLicenseStatus: id => wrapper("User.asyncLicenseStatus", id),

  /**
   * resendActivationEmail - Jigsaw.User.resendActivationEmail
   * @param {Object} params
   * @param {string} params.email - email to resend to
   * @param {string} params.url - root url to redirect activation back to (for branding)
   */
  resendActivationEmail: params =>
    wrapper("User.resendActivationEmail", params),

  /**
   * getMarkers - get all markers for the logged in user. Jigsaw.User.getMarkers
   */
  getMarkers: () => wrapper("User.getMarkers"),

  /**
   * getMarker - get a marker by id. Jigsaw.User.getMarker
   * @param {string} globalId - the global id of the marker
   */
  getMarker: globalId => wrapper("User.getMarker", globalId),

  /**
   * createMarker - create a new marker. Jigsaw.User.createMarker
   * @param {Object} params - New marker params
   * @param {string} params.label - Marker label
   * @param {boolean} params.friendsOnly - Is this only for friends? [deprecated]
   * @param {boolean} params.shared - Is this a public highlighter?
   * @param {string} params.color - Marker color
   * @param {string} params.vstColor - VST Marker Color
   * @param {string} params.vstColorDark - Dark VST Marker Color
   */
  createMarker: params => wrapper("User.createMarker", params),

  /**
   * deleteMarker - delete a marker by id. Jigsaw.User.deleteMarker
   * @param {Object} params - parameters for marker deletion
   * @param {string} params.id - the global id of the marker
   * @param {string} [params.mergeWith] - the global id of the marker you want to merge this marker into
   */
  deleteMarker: params => wrapper("User.deletMarker", params),

  /**
   * updateMarker - updates a marker. Jigsaw.User.updateMarker
   * @param {string} globalId - Global id of marker to update
   * @param {Object} params - Params to update
   * @param {string} [params.label] - Marker label
   * @param {boolean} [params.friendsOnly] - Is this only for friends? [deprecated]
   * @param {boolean} [params.shared] - Is this a public highlighter?
   * @param {string} [params.color] - Marker color
   * @param {string} [params.vstColor] - VST Marker Color
   * @param {string} [params.vstColorDark] - Dark VST Marker Color
   */
  updateMarker: (globalId, params) =>
    wrapper("User.updateMarker", globalId, params),

  /**
   * redeemCode - delete a marker by id. Jigsaw.User.redeemCode
   * @param {string} code - code to redeem
   */
  redeemCode: code => wrapper("User.redeemCode", code),

  /**
   * setInfo - sets user info
   * @param {Object} params - user params
   * @param {string} [params.email] - user email
   * @param {string} [params.eulaAccepted] - has the user accepted the eula
   * @param {string} [params.firstName] - user first name
   * @param {string} [params.lastName] - user first name
   * @param {string} [params.locale] - the user's language
   * @param {integer} [params.questionId] - the user's security question id
   * @param {boolean} [params.nps] - has the user seen the nps score
   * // probably some more params I'm forgetting,
   * //  because you CAN set question answer somewhere
   */
  setInfo: params => wrapper("User.setInfo", params),

  /**
   * setInfo - sets user info
   * @param {Object} params - user params
   * @param {string} [params.brandName] - which brand name is this account created as
   * @param {string} [params.redirect] - where to redirect the user post-verification
   * @param {string} [params.error] - where to redirect the user on verification error
   */
  requestEmailVerification: params =>
    wrapper("User.requestEmailVerification", params),

  signOut: () =>
    wrapper("User.signOut").catch(data => {
      if (data.code === 401) {
        return data;
      } else {
        return Promise.reject(data);
      }
    })
};
